import { FlowNode, NodesSampleData } from '../flowState';
import isValidSampleStatus from './isValidSampleStatus';
import getSampleStatus from './getSampleStatus';

const isValidSample = (
  node: FlowNode,
  { taskState, dirtyTaskState, nodeLoading, staleSamples }: NodesSampleData
) =>
  isValidSampleStatus(
    node,
    getSampleStatus(node, {
      taskState,
      dirtyTaskState,
      nodeLoading,
      staleSamples,
    })
  );

export default isValidSample;
